import { getUserInfo } from '@/auth'
export function hasRouterPermission(router, permissionList) {
  if (router.meta?.permission) {
    return router.meta.permission.some(item => permissionList.includes(item))
  }
  return true
}

export function hasPermission(list, mode) {
  let res = false
  if (mode.role) {
    let roles = getUserInfo().Roles
    list.forEach(val => {
      if (roles.filter(role => val === role.RoleId).length !== 0) {
        res = true
      }
    })
  } else if (mode.auth) {
    let auths = getUserInfo().Auths
    list.forEach(val => {
      if (auths.filter(auth => auth.AuthId === val).length !== 0) {
        res = true
      }
    })
  }
  return res
}
